<template>
    <div class="persons-picker dropdown search-component" :class="{ open: showDropdown, 'inline': inline }">
        <button class="btn not d-flex flex-row align-items-center" type="button" @click="toggleDropdown">
            <div class="group">
                <span class="label-text" v-if="! inline">
                    {{ 'search.personsPicker.label' | trans }}
                </span>

                <!-- Icon -->
                <i class="icon far fa-user-friends" v-if="inline"></i>

                <span class="persons-text">
                    {{ adults + children.length }} {{ 'checkout.steps.calendar.guests' | choice(adults + children.length) }}
                </span>
            </div>
        </button>

        <div class="dropdown-menu dropdown-menu-sm-left dropdown-menu-md-right" aria-labelledby="dropdownMenuButton" :class="{ show: showDropdown }">
            <!-- Adults -->
            <div class="adults">
                <label>
                    {{ 'nav.filterbar.adults' | trans }}

                    <small>
                        {{ 'nav.filterbar.adultsInfo' | trans }}
                    </small>
                </label>

                <div class="float-right">
                    <button type="button" class="btn decrease" @click="adults = (adults > 1 ? adults - 1 : 1)">
                        <i class="fa fa-minus"></i>
                    </button>

                    <span class="amount">{{ adults }}</span>

                    <button type="button" class="btn increase" @click="adults++">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
            </div>

            <div class="divider"></div>

            <!-- Children -->
            <div class="children">
                <label>
                    {{ 'nav.filterbar.children' | trans }}

                    <small>
                        {{ 'nav.filterbar.childrenInfo' | trans }}
                    </small>
                </label>

                <div class="float-right">
                    <button type="button" class="btn decrease" @click="decreaseChildren()">
                        <i class="fa fa-minus"></i>
                    </button>

                    <span class="amount">{{ children.length }}</span>

                    <button type="button" class="btn increase" @click="increaseChildren()">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>

                <!-- Children ages -->
                <div class="children-age" v-for="(child, index) in children" :class="{ first : index === 0 }" :key="child.id">
                    <label>
                        {{ 'checkout.steps.calendar.children' | choice(1) }} {{ index + 1 }}
                        <small>
                            {{ 'checkout.steps.calendar.childrenBirthdate' | trans }}
                        </small>
                    </label>

                    <div class="birthdate">
                        <div class="input">
                            <input type="number" class="day" min="0" v-model="child.birthdate.day" :placeholder="'checkout.steps.calendar.childrenBirthdateDD' | trans" @keyup="jumpEnterBirthdate" @keydown="validateEnterBirthdate" @focus="clearBirthdateInput($event);child.birthdate.day = null;">
                            <input type="number" class="month" min="0" v-model="child.birthdate.month" :placeholder="'checkout.steps.calendar.childrenBirthdateMM' | trans" @keyup="jumpEnterBirthdate" @keydown="validateEnterBirthdate" @focus="clearBirthdateInput($event);child.birthdate.month = null;">
                            <input type="number" class="year" min="1940" v-model="child.birthdate.year" :placeholder="'checkout.steps.calendar.childrenBirthdateYYYY' | trans" @keyup="jumpEnterBirthdate" @keydown="validateEnterBirthdate" @focus="clearBirthdateInput($event);child.birthdate.year = null;">
                        </div>

                        <small class="age">
                            <span v-if="(child.birthdate.day !== null && child.birthdate.day.length > 0) && (child.birthdate.month !== null && child.birthdate.month.length > 0) && (child.birthdate.year !== null && child.birthdate.year.length === 4) && calculateChildAge(child) < 18">
                                {{ calculateChildAge(child) }}
                                {{ 'checkout.steps.calendar.years' | choice(calculateChildAge(child)) }}
                            </span>
                            <!-- Check for errors -->
                            <span v-if="validateChild(child).length > 0">
                                <span class="text-danger" v-for="error in validateChild(child)">
                                    {{ 'checkout.steps.calendar.' + error | trans }}
                                </span>
                            </span>
                        </small>
                    </div>
                </div>
            </div>

            <div class="row apply-cancel">
                <div class="col-sm-6 text-center">
                    <button type="button" class="btn btn-link text-dark btn-block" @click="toggleDropdown">
                        {{ 'checkout.steps.calendar.personsCancel' | trans }}
                    </button>
                </div>

                <div class="col-sm-6 text-center">
                    <button type="button" class="btn btn-primary btn-block" @click="applyPersons('persons')">
                        {{ 'checkout.steps.calendar.personsApply' | trans }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['inline', 'originPersons'],
        data() {
            return {
                showDropdown: false,
                adults: 2,
                children: [],
                errors: [],
                tmpAdults: 2,
                tmpChildren: [],
            }
        },
        mounted() {
            this.$emit('changePersons', this.buildPersons())

            // Read query params
            let params = this.$route.query

            // Adults
            if (params.adults) {
                this.adults = parseInt(params.adults, 10);
            }

            // Children
            if (params.children) {
                this.children = params.children.split(',').map((birthdate, childIndex) => {
                    return {
                        id: childIndex,
                        day: moment(birthdate).format('DD'),
                        month: moment(birthdate).format('MM'),
                        year: moment(birthdate).format('YYYY'),
                    }
                })
            }

            // Keep origin period
            this.loadOrigin()
        },
        computed: {},
        methods: {
            toggleDropdown() {
                if (this.$root.$refs.search) {
                    this.$root.$refs.search.hideDropdowns('personsPicker')
                }

                // Save selection
                if (this.showDropdown) {
                    this.adults = this.tmpAdults;
                    this.children = JSON.parse(JSON.stringify(this.tmpChildren));
                } else {
                    this.tmpAdults = this.adults;
                    this.tmpChildren = JSON.parse(JSON.stringify(this.children));
                }

                this.showDropdown = ! this.showDropdown
            },
            hideDropdown() {
                this.showDropdown = false
            },
            applyPersons() {
                this.validatePersons();

                // Prevent if there are validation errors
                if (this.errors.length > 0) {
                    return;
                }

                this.tmpAdults = this.adults;
                this.tmpChildren = JSON.parse(JSON.stringify(this.children));

                this.showDropdown = false

                this.$emit('changePersons', this.buildPersons())
            },
            validatePersons() {
                // Reset errors
                this.errors = [];

                let errors = []
                for(var i = 0; i < this.children.length; i++) {
                    errors = [
                        ...errors,
                        ...this.validateChild(this.children[i]),
                    ]
                }

                this.errors = errors
            },
            validateChild(child) {
                let errors = []

                // Check if no birthdate is invalid
                if (! ((child.birthdate.day !== null && child.birthdate.day.length > 0) && (child.birthdate.month !== null && child.birthdate.month.length > 0) && (child.birthdate.year !== null && child.birthdate.year.length === 4))) {
                    errors.push('invalidBirthdate');

                    return errors;
                }


                // Check if child >= 18
                if (this.calculateChildAge(child) >= 18) {
                    errors.push('childIsTooOld');

                    return errors;
                }

                return errors
            },
            increaseChildren: function() {
                this.children.push({
                    id: this.children.length,
                    birthdate: {
                        day: null,
                        month: null,
                        year: null
                    }
                });
                setTimeout(function() {
                    $('div.calendar div.children-age').last().find('div.birthdate input.day').focus();
                }, 200)
            },
            decreaseChildren: function() {
                this.children.pop();
            },
            calculateChildAge: function(child) {
                return this.$moment().diff(this.getChildBirthdateString(child), 'years', false);
            },
            getChildBirthdateString: function(child) {
                var year = child.birthdate.year;
                var month = parseInt(child.birthdate.month, 10) < 10 ? '0' + parseInt(child.birthdate.month, 10) : '' + child.birthdate.month;
                var day = parseInt(child.birthdate.day, 10) < 10 ? '0' + parseInt(child.birthdate.day, 10) : '' + child.birthdate.day;
                var birthdateString = year + '-' + month + '-' + day;

                return birthdateString;
            },
            clearBirthdateInput: function(event) {
                event.target.value = '';
            },
            validateEnterBirthdate: function(event) {
                var value = event.target.value;
                var newValue = parseInt('' + event.target.value + event.key, 10);

                if (event.key === 'Backspace') return true;

                // Max length
                switch (event.target.className) {
                    case 'day':
                        if (value.length > 2 || newValue > 31) {
                            event.preventDefault();
                        } else if (value.length === 2) {
                            event.target.value = '';
                        }
                        break;

                    case 'month':
                        if (value.length > 2 || newValue > 12) {
                            event.preventDefault();
                        } else if (value.length === 2) {
                            event.target.value = '';
                        }
                        break;

                    case 'year':
                        if (value.length > 4) {
                            event.preventDefault();
                        } else if (value.length === 4) {
                            event.target.value = '';
                        }
                        break;
                }
            },
            jumpEnterBirthdate: function(event) {
                if (event.target.className !== 'year' && event.target.value.length === 2) {
                    event.target.nextElementSibling.focus();
                }
            },
            buildPersons: function() {
                var persons = [];
                persons.push({
                    type: 'adult',
                    birthdate: '1990-01-01',
                    amount: this.adults,
                });

                for (var i = 0; i < this.children.length; i++) {
                    var child = this.children[i];
                    persons.push({
                        type: 'child',
                        birthdate: this.getChildBirthdateString(child),
                        amount: 1
                    });
                }

                return persons;
            },

            loadOrigin() {
                if (! (this.originPersons && this.originPersons.length > 0)) {
                    return;
                }

                let adults = 0;
                let children = [];

                for (var i = 0; i < this.originPersons.length; i++) {
                    // Adult
                    if (this.originPersons[i].type === 'adult') {
                        adults += this.originPersons[i].amount;
                    }

                    // Children
                    if (this.originPersons[i].type === 'child') {
                        const birthdateString = this.originPersons[i].birthdate.split('-');
                        children.push({
                            id: children.length,
                            birthdate: {
                                day: birthdateString[2],
                                month: birthdateString[1],
                                year: birthdateString[0],
                            },
                        });
                    }
                }

                this.adults = adults
                this.children = children
            },
        },
        watch: {
            originPersons: {
                handler(val) {
                    if (this.originPersons && this.originPersons.length > 0) {
                        this.loadOrigin();
                    }
                },
                deep: true,
            }
        }
    }
</script>
